'use client'

import { featureFlagsAtom } from '@polaris/core/stores'
import { useAtomValue } from 'jotai'
import type { PropsWithChildren } from 'react'
import { Banner } from '@/src/components/ui/banner'

export function MaintenanceBanner({ children }: PropsWithChildren) {
  const { maintenanceBanner } = useAtomValue(featureFlagsAtom)

  return maintenanceBanner.enabled ? (
    <Banner
      className='bg-transparent m-5 border-2 border-border2 rounded-3xl'
      variant='warning'
      alertTitle={maintenanceBanner.title}
      description={maintenanceBanner?.subtitle}
    />
  ) : (
    children
  )
}
